import { Threshold } from './Threshold'

export class Legend {
  constructor(
    readonly titleTranslationKey: string,
    readonly thresholds: Threshold[],
    readonly mode: 'linear' | 'distributed' = 'linear',
  ) {}

  get thresholdCount(): number {
    return this.thresholds.length
  }

  getThresholdMatching(value: number): Threshold {
    for (let i = this.thresholdCount - 1; i >= 0; --i) {
      const threshold = this.thresholds[i]
      if (value >= threshold.value) {
        return threshold
      }
    }
    return this.thresholds[0]
  }
}
